// «Copiar tabla» (ios/Sources/Views/MarkdownTableView.swift `copyTable`, PARITY P313): a drawn
// Markdown table goes to the clipboard as BOTH an HTML table (what a document or a mail paste keeps
// as a grid) and tab-separated values (what a spreadsheet parses back into cells). Pure: the page
// writes the two flavours (ui/features/extras/tableCopy.ts).

/** The rows that are copied: the header only when it says something ("no header" is presentation). */
function copyRows(header: readonly string[], rows: readonly (readonly string[])[]): string[][] {
  const hasHeader = header.some((h) => h !== '');
  return [...(hasHeader ? [header.slice()] : []), ...rows.map((r) => r.slice())];
}

/** Tab-separated values: a tab or a newline inside a cell would split it, so they become spaces. */
function tsv(header: readonly string[], rows: readonly (readonly string[])[]): string {
  return copyRows(header, rows)
    .map((row) => row.map((cell) => cell.replaceAll('\t', ' ').replaceAll('\n', ' ')).join('\t'))
    .join('\n');
}

function escape(text: string): string {
  return text.replaceAll('&', '&amp;').replaceAll('<', '&lt;').replaceAll('>', '&gt;');
}

/** The same table as HTML, escaped, `<thead>` only for a header that says something. */
function html(header: readonly string[], rows: readonly (readonly string[])[]): string {
  let out = '<table>';
  if (header.some((h) => h !== '')) out += '<thead><tr>' + header.map((h) => `<th>${escape(h)}</th>`).join('') + '</tr></thead>';
  out += '<tbody>';
  for (const row of rows) out += '<tr>' + row.map((c) => `<td>${escape(c)}</td>`).join('') + '</tr>';
  return out + '</tbody></table>';
}

export const MarkdownTableCopy = { tsv, html } as const;
